module.exports = __webpack_public_path__ + "static/media/paper.21f989c3.svg";